import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Button } from "antd";
import notFoundBg from "../../assets/svg/notFoundBg.svg";
import "./not-found.scss";

const NotFound: React.FC<any> = () => {
  const history = useHistory();
  const location: any = useLocation();
  const { navigateTo, buttonText, message } = location.state || {};

  const handleNavigation = () => {
    history.push(navigateTo || "/home");
  };

  return (
    <div
      className="not-found"
      style={{ backgroundImage: `url(${notFoundBg})` }}
    >
      <h1>404</h1>
      <span>Page not found</span>
      <p>
        {message ||
          "The link you clicked may be broken or the page may be removed or renamed"}
      </p>
      <Button
        data-test-id="home"
        onClick={handleNavigation}
        type="primary"
        size="large"
        style={{
          backgroundColor: "#1B80FF",
          border: "1px solid #1B80FF",
          borderRadius: "none",
        }}
      >
        {buttonText || "Go Home"}
      </Button>
    </div>
  );
};

export default NotFound;
